import ApisixAdminClient from './client';
export default ApisixAdminClient;

export type * from '../types/client.d.ts';
export type * from '../types/admin/route.d.ts';
export type * from '../types/admin/upstream.d.ts';
